import React, { Component } from "react";
import axios from "axios";
import { awsAcordUpload } from "../../config";
import SmallLoader from "./smallLoader";
import moment from "moment";
import { quesList } from "../../utils/ques_list";
import { isExistingBusiness } from "../../utils/fieldAccess";
import { Auth } from "../../utils/amplifyAuth";
import { validateFile } from "../../utils/validateFile";

class UploadFormAcord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadingFile: false,
      awaitingFile: false,
      parseError: false,
      parseMesssage: "",
      urlSuccess: false,
      signedUrl: "",
      validating: false, // true while async file validation is in progress
    };
  }

  createFormFieldData = (data) => {
    // remove the default responses from the first 24 acord questions
    let uw_questions = quesList;
    try {
      for (let i = 0; i < 24; i++) {
        delete uw_questions[i].response;
      }
    } catch (error) { }

    try {
      let street2, state2, zipCode2, city2;
      try {
        if (data?.basic_information?.mailing_address?.location_details) {
          street2 =
            data.basic_information.mailing_address.location_details?.address ||
            "";
          state2 =
            data.basic_information.mailing_address.location_details?.state ||
            "";
          zipCode2 =
            data.basic_information.mailing_address.location_details?.pincode ||
            "";
          city2 =
            data.basic_information.mailing_address.location_details?.city || "";
        } else if (data?.basic_information?.mailing_address?.address) {
          street2 = data.basic_information.mailing_address.address;
        }
      } catch (error) { }

      let street1, state1, zipCode1, city1;
      try {
        if (data?.basic_information?.primary_address?.location_details) {
          street1 =
            data.basic_information.primary_address.location_details?.address ||
            "";
          state1 =
            data.basic_information.primary_address.location_details?.state ||
            "";
          zipCode1 =
            data.basic_information.primary_address.location_details?.pincode ||
            "";
          city1 =
            data.basic_information.primary_address.location_details?.city || "";
        } else if (data?.basic_information?.primary_address?.address) {
          street1 = data.basic_information.primary_address.address;
        }
      } catch (error) { }

      let companyProfile = {
        lastName: {
          value: data.basic_information.contact_information?.last_name || "",
        },
        expectedStartDate: {
          value: moment(data.basic_information.eff_date || ""),
        },
        cityName1: { value: city1 || "" },
        zipCode1: { value: zipCode1 || "" },
        cityName2: { value: city2 || "" },
        zipCode2: { value: zipCode2 || "" },
        entityType: { value: "" },
        companyName: { value: data.basic_information.company_name || "" },
        fein: { value: data.basic_information.fein || "" },
        state2: { value: state2 || "" },
        state1: { value: state1 || "" },
        yearsInBusiness: {
          value: data.basic_information.years_in_business || "",
        },
        firstName: {
          value: data.basic_information.contact_information?.first_name || "",
        },
        phoneNumber: {
          value:
            data.basic_information.phone_number ||
            data.basic_information.mobile_number ||
            "",
        },
        descriptionOfOperations: { value: data.basic_information.desc || "" },
        street1: { value: street1 || "" },
        street2: { value: street2 || "" },
        effectiveDate: {
          value: moment(data.basic_information.eff_date || ""),
        },
        expectedExpiryDate: {
          value:
            data.basic_information.eff_date &&
            moment(data.basic_information.eff_date).isValid()
              ? moment(data.basic_information.eff_date)
                  .add(1, "year")
                  .startOf("year")
              : moment().add(1, "year").startOf("year"),
        },
      };

      // prepare children loc
      let locationClassCodeCurrentIndex = {};
      let childrenLoc = {};

      for (let ccIndex in data.state_details) {
        let state = data.state_details[ccIndex].location_details?.state;

        let locNumber;
        try {
          locNumber =
            String(Number(data.state_details[ccIndex].LOC) - 1) ||
            Number(ccIndex) + 1;
        } catch (error) {
          locNumber = data.state_details[ccIndex].LOC || Number(ccIndex) + 1;
        }
        let payroll;

        try {
          let remuneration = data.state_details[ccIndex].REMUNERATION;

          let isNumber = !isNaN(
            remuneration?.trim()?.replace("$", "")?.replace(/,/g, ""),
          );
          if (isNumber) {
            payroll = remuneration?.trim()?.replace("$", "");
          }
        } catch (error) {
          console.log(error);
        }

        // initialize/update the current index for the class code for this location
        if (!(locNumber in locationClassCodeCurrentIndex)) {
          locationClassCodeCurrentIndex[locNumber] = -1;
        }
        locationClassCodeCurrentIndex[locNumber]++;

        if (!childrenLoc[locNumber]) {
          let cityName = "";
          let street = "";
          try {
            cityName = data.state_details[ccIndex].location_details?.city;
            street = data.state_details[ccIndex].location_details?.address;
          } catch (error) { }
          childrenLoc[locNumber] = {
            number: locNumber,
            zipCode: {
              value:
                data.state_details[ccIndex].location_details?.pincode || "",
            },
            cityName: {
              value: cityName || "",
            },
            street: {
              value: street || "",
            },
            state: {
              value: state || "",
            },
            classCodesInfo: { 0: {} },
          };
        }
        childrenLoc[locNumber].classCodesInfo[
          locationClassCodeCurrentIndex[locNumber]
        ] = {
          classCodeDescription: {
            error: false,
            value:
              data.state_details[ccIndex].CLASS +
              ": " +
              data.state_details[ccIndex].DESCR || " ",
          },
          payroll: {
            value: payroll ? "$" + payroll : "$ ",
          },
          pt: {
            value: data.state_details[ccIndex].PART || "",
          },
          ft: {
            value: data.state_details[ccIndex].FULL || "",
          },
          fromAcord: true,
        };
      }

      // parse included and excluded officers details (1 object in array = 1 row)
      let officersList = [];
      try {
        let incExcData = data?.included_excluded_details;
        if (incExcData && Array.isArray(incExcData) && incExcData.length > 0) {
          incExcData.forEach((item) => {
            if (!item || typeof item !== "object") return;

            const getProp = (keys) => {
              for (let k of keys) {
                if (item[k] !== undefined && item[k] !== null) {
                  return String(item[k]).trim();
                }
              }
              return "";
            };
            const rawName = getProp(["NAME"]);
            const rawOwnership = getProp(["OWNERSHIP"]);
            const rawState = getProp(["STATE"]);
            const rawIncExc = getProp(["INC/EXC"]);
            const rawClassCode = getProp(["CLASSCODE"]);
            const rawLocNumber = getProp(["LOC"]);
            const rawDuties = getProp(["DUTIES"]);
            const rawPayroll = getProp(["PAYROLL"]);

            // Ownership: clean and take first number if repeated (e.g. "50.00 50.00" -> "50.00")
            let ownership = "";
            if (rawOwnership) {
              const numMatch = rawOwnership.match(/\d+(?:\.\d+)?/);
              ownership = numMatch
                ? numMatch[0]
                : rawOwnership.replace("%", "").trim();
            }

            // State: clean and take first 2-letter state code if repeated (e.g. "CA CA" -> "CA")
            let state = "";
            if (rawState) {
              const stateMatch = rawState.match(/[A-Za-z]{2}/);
              state = stateMatch
                ? stateMatch[0].toUpperCase()
                : rawState.trim().toUpperCase();
            }

            // Inclusion: INCLUDED or EXCLUDED
            let inclusionType = "";
            if (rawIncExc) {
              if (rawIncExc.toLowerCase().includes("inc")) {
                inclusionType = "INCLUDED";
              } else if (rawIncExc.toLowerCase().includes("exc")) {
                inclusionType = "EXCLUDED";
              }
            }

            // Loc number: numeric, max 3 digits
            let locNumber = "";
            if (rawLocNumber) {
              const locMatch = rawLocNumber.match(/\d{1,3}/);
              locNumber = locMatch ? locMatch[0] : rawLocNumber.replace(/\D/g, "").slice(0, 3);
            }

            // Duties: default "Executive" if empty, or rawDuties
            let duties = rawDuties || "Executive";

            // Payroll: whole numbers only
            let payroll = "";
            if (rawPayroll) {
              const cleanPay = rawPayroll.replace(/[^0-9]/g, "");
              if (cleanPay) {
                payroll = cleanPay;
              }
            }

            if (rawName || ownership || state || rawClassCode || locNumber || payroll) {
              officersList.push({
                state: state || "",
                locNumber: locNumber || "",
                name: rawName || "",
                ownership: ownership || "",
                duties: duties,
                inclusionType: inclusionType || "",
                classCode: rawClassCode || "",
                payroll: payroll || "",
              });
            }
          });
        }
      } catch (err) {
        console.log("error while parsing included_excluded_details", err);
      }

      let result = {
        companyProfile,
        childrenLoc,
        officersList,
      };

      if (data?.uw_questions?.length) {
        for (let localIndex in data.uw_questions) {
          let question = data.uw_questions[localIndex];
          let response =
            question?.response?.includes("Y") || question?.yes
              ? true
              : question?.response?.includes("N") || question?.no
                ? false
                : undefined;
          if (response !== undefined) {
            uw_questions[localIndex].response = response;
          }
        }
        sessionStorage.setItem("acordUwQues", JSON.stringify(uw_questions));
      }

      // prepare historical claims
      try {
        if (data?.historical_claims) {
          let acordHistoricalClaims = data.historical_claims;
          sessionStorage.setItem(
            "acordHistoricalClaims",
            JSON.stringify(acordHistoricalClaims),
          );
        }
      } catch (error) { }

      console.log(result);
      this.props.updateFormFields(result);
    } catch (error) {
      console.log("error while parsing acord results", error);
    }
  };

  handleLossOcrParse = (data) => {
    this.setState({ awaitingFile: false, disableBind: false });
    if (data.fileType === "success") {
      this.setState({
        parseMesssage: "Parsing complete!",
        parseError: false,
        urlSuccess: true,
        signedUrl: data.url,
      });
      this.createFormFieldData(data.data);
    } else if (data.fileType === "error") {
      this.setState({
        parseMesssage:
          "Unable to process the loss file. Please contact admin@insurecomp.com for further clarification.",
        parseError: true,
      });
    } else {
      this.setState({
        parseMesssage:
          "Unable to generate the download link. Please contact admin@insurecomp.com for further clarification.",
        parseError: true,
      });
    }
  };

  s3Poller = (fileName) => {
    axios
      .get(
        awsAcordUpload +
        `/api/s3PollerJson/ocr-doc-demo-acord/${fileName}/us-east-1`,
      )
      .then((result) => {
        if (result.data.fileType) {
          console.log("here in");
          this.handleLossOcrParse(result.data);
        } else {
          this.s3Poller(fileName);
        }
      })
      .catch((err) => {
        console.log("Error", err);
        this.setState({
          parseError: true,
          awaitingFile: false,
          parseMesssage:
            "Unable to process the loss file. Please contact admin@insurecomp.com for further clarification.",
        });
      });
  };

  handleFileUpload = async (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    this.setState({
      file: event.target.files,
      validating: true,
      parseError: false,
      parseMesssage: "",
    });

    if (
      file.type !== "application/pdf" ||
      !file.name.toLowerCase().endsWith(".pdf")
    ) {
      this.setState({
        validating: false,
        parseError: true,
        parseMesssage: "Wrong format selected. Select a PDF file.",
      });
      return;
    }

    // Corruption & Empty File validation (0 bytes, magic number, deep structural parse, blank PDF)
    const validation = await validateFile(file);
    if (!validation.valid) {
      this.setState({
        validating: false,
        parseError: true,
        parseMesssage: validation.error,
      });
      return;
    }

    this.setState({
      validating: false,
      parseError: false,
      parseMesssage: "",
    });

    if (this.props.onFileSelect) {
      this.props.onFileSelect(file);
    }
    console.log("File selected and validated:", file.name);
  };

  uploadFile = async (event) => {
    this.props.continueErr();

    // block if validation is still running or parse error exists
    if (this.state.validating || this.state.parseError) return;

    // block if no file is selected
    if (!this.state.file || !this.state.file[0]) {
      this.setState({
        parseError: true,
        parseMesssage: "Please upload a file.",
      });
      return; // Exit the function
    }

    // Reset any previous error state
    this.setState({
      uploadingFile: true,
      parseError: false,
      error: false,
      urlSuccess: false,
      signedUrl: "",
      awaitingFile: false,
    });

    const that = this;
    event.preventDefault();

    let isLoggedIn, loggedIn_emailID;
    try {
      isLoggedIn = await Auth.currentAuthenticatedUser();
      loggedIn_emailID = isLoggedIn.attributes.email;
    } catch (authErr) {
      console.log("error fetching current authenticated user:", authErr);
    }

    const formData = new FormData();
    formData.append("file", this.state.file[0]);
    let mode = process.env.REACT_APP_MODE;
    formData.append("client", "ies");
    formData.append("environment", mode);

    axios
      .post(awsAcordUpload + "/api/fileUploadAcord", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        that.setState({ uploadingFile: false });
        that.setState({ awaitingFile: true });
        const fileName = response.data.fileName;
        const folder = fileName.split(".")[0];
        console.log("file uploaded:", folder);
        this.s3Poller(folder);
        if (this.props.onFileSelect) {
          this.props.onFileSelect(this.state.file[0]);
        }
      })
      .catch((error) => {
        this.setState({ uploadingFile: false });
        console.log("error", error);
      });
  };

  render() {
    const {
      uploadingFile,
      awaitingFile,
      urlSuccess,
      signedUrl,
      parseError,
      parseMesssage,
      validating,
    } = this.state;

    let mobile_width = window.innerWidth <= 500 ? { width: "220px" } : {};
    const isDisabled = isExistingBusiness();

    return (
      <div className="acordParseform">
        <p>Select an acord document for analysis</p>
        <form className="">
          <div className="d-flex">
            <div className="form-group">
              <input
                disabled={isDisabled}
                label="upload file"
                type="file"
                onChange={this.handleFileUpload}
                className="acord_input"
                style={mobile_width}
                accept=".pdf"
              />
            </div>
            <div>
              <button
                type="button"
                className="btn btn-primary acordSubmitButton"
                onClick={this.uploadFile}
                disabled={parseError || validating || isDisabled}
                title={validating ? "Validating file, please wait..." : ""}
              >
                Submit
              </button>
            </div>
          </div>
        </form>
        <div className="">
          {uploadingFile && (
            <span>
              Uploading file <SmallLoader />
            </span>
          )}
          {awaitingFile && (
            <span>
              Waiting for file creation <SmallLoader />
            </span>
          )}
          {urlSuccess && (
            <div>
              <a href={signedUrl}>
                {parseMesssage} Click here to download your file.
              </a>
            </div>
          )}
          {parseError && (
            <div style={{ color: "red", marginTop: "0.5rem" }}>
              {parseMesssage}
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default UploadFormAcord;
